/* eslint-disable no-confusing-arrow */ 
/* eslint-disable max-len */ 
import React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { makeStyles } from '@material-ui/styles';
import { BsChevronDown } from 'react-icons/bs';

const useStyles = makeStyles((theme) => ({
  formControl: {
    '& .MuiOutlinedInput-root': {
      color: '#292E36',
      '&:hover fieldset': {
        borderColor: '#466EFF',
      },
    },
    '& .MuiSelect-icon': {
      color: '#292E36',
      right: '11px',
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
   
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      borderRadius: '8px',      
      width: 'max-content',
      marginTop: '5px',
      padding: '8px',
      // minWidth: 150,
      // maxWidth: 1400,
    },
  },

};

export default function SelectOptions({
  label,
  value,
  setValue,
  menuOptions,
  size,
  minWidth,
  maxHeight,
  disabled,
  maxWidth,
  usedIn,
  handleCustomeChange,
  actionId,
}) {
  const handleChange = (event) => {
    if (usedIn === 'users') {
      handleCustomeChange(event);
    } else if (usedIn === 'agents') {
      setValue((prevActions) => (
        prevActions.map((inaction) => inaction.id === actionId ? { ...inaction, type: event.target.value } : inaction)
      ));
    } else if (usedIn === 'agentsAssign') {
      setValue((prevActions) => (
        prevActions.map((inaction) => inaction.id === actionId ? { ...inaction, transfer_to_account_id: event.target.value } : inaction)
      ));
    } else {
      setValue(event.target.value);
    }
  };

  const classes = useStyles();
  return (
    <Box sx={{ minWidth, maxWidth, maxHeight: maxHeight ?? '40px' }}>
      <FormControl
        className={`hover:!border-[1px] border !bg-white rounded-[8px] outline-none medium ${classes.formControl}`}
        fullWidth
        size={size}
      >
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          MenuProps={MenuProps}
          onChange={handleChange}
          IconComponent={BsChevronDown}
          disabled={disabled}
          className="!rounded-[8px]"
          defaultValue=""
        >
          {menuOptions?.map((menu) => (
            <MenuItem
              className="hover:!bg-[#466EFF] !mt-1 hover:!text-white !rounded-[10px] !text-[#1a202c]"
              key={menu.value}
              value={menu.value}
            >
              {menu.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
